import { FC } from 'react';

import s from './EmptyState.module.css';

const EmptyMovie: FC = () => {
  return (
    <svg
      width="123"
      height="119"
      viewBox="0 0 123 119"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M113.645 115.71H12.335C10.1257 115.71 8.33496 113.919 8.33496 111.71V49.52H117.645V111.71C117.645 113.919 115.854 115.71 113.645 115.71Z"
        className={s.backgroundAndBorder}
        strokeWidth="5"
      />
      <path d="M122.205 40.51H3.7749V52.83H122.205V40.51Z" className={s.lighterFillColor} />
      <path
        d="M65.1349 52.84H76.7649L83.4249 40.52H71.7949L65.1349 52.84ZM19.3149 52.84H30.9449L37.6049 40.52H25.9749L19.3149 52.84ZM42.2249 52.84H53.8549L60.5149 40.52H48.8849L42.2249 52.84ZM88.0449 52.84H99.6749L106.335 40.52H94.7049L88.0449 52.84ZM117.615 40.52L110.955 52.84H122.195V40.52H117.615ZM3.7749 52.84H8.0249L14.6849 40.52H3.7749V52.84Z"
        className={s.darkerFillColor}
      />
      <path
        d="M115.739 0.00630503L0.801758 28.5568L3.7718 40.5135L118.709 11.9629L115.739 0.00630503Z"
        className={s.lighterFillColor}
      />
      <path
        d="M69.7849 24.11L81.0649 21.31L71.6349 10.96L60.3549 13.76L69.7849 24.11ZM25.3149 35.16L36.5949 32.36L27.1649 22.01L15.8849 24.81L25.3149 35.16ZM47.5549 29.64L58.8349 26.84L49.4049 16.49L38.1249 19.29L47.5549 29.64ZM92.0249 18.59L103.305 15.79L93.8749 5.44L82.5949 8.24L92.0249 18.59ZM118.705 11.96L115.735 0L104.825 2.71L114.255 13.06L118.695 11.96H118.705ZM3.76492 40.51L14.3549 37.88L4.92492 27.53L0.794922 28.56L3.76492 40.52V40.51Z"
        className={s.darkerFillColor}
      />
      <path
        d="M7.43473 33.97C7.43473 34.89 6.68473 35.64 5.76473 35.64C4.84473 35.64 4.09473 34.89 4.09473 33.97C4.09473 33.05 4.84473 32.3 5.76473 32.3C6.68473 32.3 7.43473 33.05 7.43473 33.97Z"
        className={s.lighterFillColor}
      />
      <path
        d="M7.24471 48.39C8.16702 48.39 8.91471 47.6423 8.91471 46.72C8.91471 45.7977 8.16702 45.05 7.24471 45.05C6.32239 45.05 5.57471 45.7977 5.57471 46.72C5.57471 47.6423 6.32239 48.39 7.24471 48.39Z"
        className={s.lighterFillColor}
      />
      <path
        d="M76.5869 80.2933L55.9469 69.9733C55.6684 69.8443 55.3622 69.787 55.0559 69.8066C54.7497 69.8262 54.4532 69.9221 54.1934 70.0855C53.9337 70.249 53.719 70.4748 53.5688 70.7424C53.4186 71.01 53.3377 71.3109 53.3336 71.6178V92.2489C53.331 92.5639 53.4097 92.8742 53.562 93.1499C53.7144 93.4256 53.9354 93.6573 54.2035 93.8226C54.4716 93.9879 54.7778 94.0813 55.0926 94.0937C55.4073 94.1061 55.7199 94.0371 56.0002 93.8933L76.5869 83.5733C76.8918 83.4203 77.1482 83.1854 77.3274 82.895C77.5065 82.6046 77.6014 82.2701 77.6014 81.9289C77.6014 81.5877 77.5065 81.2532 77.3274 80.9628C77.1482 80.6724 76.8918 80.4375 76.5869 80.2844V80.2933Z"
        className={s.darkerFillColor}
      />
    </svg>
  );
};

export default EmptyMovie;
